import { render, staticRenderFns } from "./xsjnzszlb.vue?vue&type=template&id=12b49777&scoped=true"
import script from "./xsjnzszlb.vue?vue&type=script&lang=js"
export * from "./xsjnzszlb.vue?vue&type=script&lang=js"
import style0 from "./xsjnzszlb.vue?vue&type=style&index=0&id=12b49777&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b49777",
  null
  
)

export default component.exports